// How a ticket's type reads wherever a person sees it: "Appliance — Fridge"
// when a sub-type was chosen, otherwise just "Appliance". Mirrors
// Server/utils/requestSubTypes.js → requestTypeLabel.
export const requestTypeLabel = (ticket) => {
  const type = String(ticket?.requestType ?? "").trim();
  const sub = String(ticket?.requestSubType ?? "").trim();
  if (!type) return sub;
  return sub ? `${type} — ${sub}` : type;
};

// The sub-types configured for a request type, by name, from the list that
// POST /requesttype/getrequest returns. Empty when the type has none — and
// then no sub-type field should be shown at all.
export const subTypesFor = (requestTypeList, requestTypeName) => {
  const match = (requestTypeList || []).find(
    (t) => String(t?.request_type ?? "") === String(requestTypeName ?? "")
  );
  return Array.isArray(match?.sub_types)
    ? match.sub_types.map((s) => String(s ?? "").trim()).filter(Boolean)
    : [];
};
